export default __webpack_public_path__ + "static/media/499.6ad266f5.png";